import { ref, computed, onMounted } from "vue";

export const useAppData = () => {
  const version = ref(null);

  const navaApp = computed(() => [
    {
      id: 1,
      title: "نسخه ویندوز",
      icon: "109",
      url: "https://navatel.ir/download/windows/",
      version: version.value?.windows,
    },
    {
      id: 2,
      title: "نسخه اندروید",
      icon: "110",
      url: "https://navatel.ir/download/android/",
      version: version.value?.android,
    },
    {
      id: 4,
      title: "نسخه وب",
      icon: "111",
      url: "https://app.navatel.ir/",
      version: version.value?.web,
    },
  ]);

  const matamaApp = computed(() => [
    {
      id: 1,
      title: "نسخه ویندوز",
      icon: "109",
      url: "https://navatel.ir/metama/download/windows/",
      version: version.value?.matama_windows,
    },
    {
      id: 2,
      title: "نسخه اندروید",
      icon: "110",
      url: "https://navatel.ir/metama/download/android/",
      version: version.value?.matama_android,
    },
    {
      id: 3,
      title: "نسخه وب",
      icon: "111",
      url: "https://app.matama.ir/",
      version: version.value?.matama_web,
    },
  ]);

  onMounted(async () => {
    version.value = await $fetch("/version.json", {
      headers: {
        "Cache-Control": "no-cache",
      },
    });
  });

  return {
    version,
    navaApp,
    matamaApp,
  };
};
